import { apiUrl } from "../utils/api";

/**
 * Presence-/Tagesabschluss-Status (AP14). Read-only-Konsum des Aggregat-
 * Endpoints `GET /presence/day-close-status` — die Item-/Scope-Logik liegt im
 * Backend (Plan-1 `TodoService.dayCloseCountsForUser`); hier nur Anzeige/Gate.
 */

export interface DayCloseStatusDto {
    /** Persönliche, noch offene To-Dos mit fälliger TWV (≤ heute). */
    dueTwv: number;
    /** Persönliche, noch offene To-Dos mit fälliger Frist (≤ heute). */
    dueFristen: number;
    /** true, sobald irgendein Zähler > 0 — blockiert das In-App-Logout. */
    blocking: boolean;
}

async function request<T>(url: string): Promise<T> {
    const res = await fetch(url, { headers: { "Content-Type": "application/json" } });
    if (!res.ok) {
        const text = await res.text();
        throw new Error(`API error ${res.status}: ${text}`);
    }
    return res.json();
}

export const presenceService = {
    /** Tagesabschluss-Status des angemeldeten Nutzers abrufen. */
    dayCloseStatus(): Promise<DayCloseStatusDto> {
        return request<DayCloseStatusDto>(apiUrl("presence/day-close-status"));
    },
};
